<template>
    <div class="vue-tempalte">
        <div class="container mt-5 mb-5">
            <div class="row justify-content-center">
               <div class="col-md-8">
                   <form @submit.prevent="onFormSubmit">
                       <h3>Добави член на екипа</h3>

                       <div class="form-group">
                           <label>Снимка</label>
                           <input type="file" class="form-control form-control-lg"  ref="file" v-on:change="handleFileUpload()" required>
                       </div>
                       <div class="form-group">
                           <label>Име</label>
                           <input type="text" class="form-control form-control-lg" v-model="user.name" required>
                       </div>

                       <div class="form-group">
                           <label>Биография</label>
                           <div class="editor-wrapper">
                               <vue-editor v-model="user.story"  required></vue-editor>
                           </div>
                       </div>

                       <div class="form-group">
                           <button class="btn btn-primary btn-block">Add User</button>
                       </div>
                   </form>
               </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { db } from '../firebase';
    import { VueEditor } from "vue2-editor";

    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                user: {
                    name: '',
                    story: '',
                    image: '',
                    order: ''
                }
            }
        },
        methods: {
            onFormSubmit(event) {
                event.preventDefault();
                db.collection('team').add(this.user).then(() => {
                    alert("Team member successfully created!");
                    this.user.name = '';
                    this.user.image = null;
                    this.user.story = '';
                    this.user.order = '';
                }).catch((error) => {
                    console.log(error);
                });
            },

            handleFileUpload(){
                const reader = new FileReader();
                reader.readAsDataURL(this.$refs.file.files[0]);
                reader.onload = ()=> {
                    this.user.image = reader.result;
                };
            }
        }
    }
</script>
